import { graphql } from '@/gql';
import type { ExpiringCreditsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedExpiringCreditTypeResponse } from '@/models/payment';

export const fetchExpiringCredits = async ({
  phoneNumber,
  pagination,
}: ExpiringCreditsQueryVariables): Promise<PaginatedExpiringCreditTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query ExpiringCredits($phoneNumber: String!, $pagination: PaginationInputType) {
        expiringCredits(phoneNumber: $phoneNumber, pagination: $pagination) {
          count
          rows {
            id
            service
            subsidyCount
            subsidyAmt
            subsidyType
            subsidyTarget
            maxSubsidyAmt
            promoCode
            expiresAt
            createdAt
            creator {
              fullName
            }
          }
        }
      }
    `),
    variables: {
      phoneNumber,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.expiringCredits;
};
